import { userStore, types } from "@/BaseComponent";
import { apiService, header } from "@/services/interceptor";
import { ReqBoardCommentForRemove } from "@/types";

export default {
    async list(param: types.ReqBoardList): Promise<types.ResPaging> {
        const res = {} as types.ResPaging;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/board/suggest/list", param, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async detail(idx: number): Promise<types.ResBoard> {
        const res = {} as types.ResBoard;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/board/suggest/detail/" + idx, null, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async add(param: types.ReqBoardForSuggest): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            const formData: FormData = new FormData();
            Object.entries(param).forEach(([key, value]) => {
                if (value instanceof File || value instanceof Blob) {
                    formData.append(key, value);
                } else if (value instanceof Array) {
                    value.forEach((item) => {
                        formData.append(key, item);
                    });
                } else if (value !== undefined && value !== null) {
                    formData.append(key, String(value));
                }
            });
            header.headers["Content-Type"] = "multipart/form-data";
            const response = await apiService().post("/board/suggest/add", formData, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async modify(idx: number, param: types.ReqBoardForSuggestForModify): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            const formData: FormData = new FormData();
            Object.entries(param).forEach(([key, value]) => {
                if (value instanceof File || value instanceof Blob) {
                    formData.append(key, value);
                } else if (value instanceof Array) {
                    value.forEach((item) => {
                        formData.append(key, item);
                    });
                } else if (value !== undefined && value !== null) {
                    formData.append(key, String(value));
                }
            });
            header.headers["Content-Type"] = "multipart/form-data";
            const response = await apiService().post("/board/suggest/modify/" + idx, formData, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async remove(idx: number): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/board/suggest/remove/" + idx, null, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async removeFile(idx: number, idxFile: number): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/board/suggest/remove/" + idx + "/" + idxFile, null, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async commentList(idx: number, param: types.ReqBoardCommentList): Promise<types.ResPaging> {
        const res = {} as types.ResPaging;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/board/suggest/comment/list/" + idx, param, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async commentAdd(idx: number, param: types.ReqBoardComment): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            const response = await apiService().post("/board/suggest/comment/add/" + idx, param, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async commentModify(idx: number, param: types.ReqBoardCommentForModify): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            const response = await apiService().post("/board/suggest/comment/modify/" + idx, param, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async commentDelete(idx: number, param: ReqBoardCommentForRemove): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/board/suggest/comment/delete/" + idx, param, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },
};
